/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Repeat_Words_LabelInputs */

const en_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repeat Words`)
};

const fr_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mots repetes`)
};

const de_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wörter wiederholen`)
};

const it_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripeti le parole`)
};

const ru_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить слова`)
};

const es_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetir palabras`)
};

const zh_cn2_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重复词语`)
};

const ja_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語を繰り返す`)
};

const hi_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शब्दों को दोहराएँ`)
};

const pt_pt2_style_guide_manager_repeat_words_label = /** @type {(inputs: Style_Guide_Manager_Repeat_Words_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repita as palavras`)
};

/**
* | output |
* | --- |
* | "Repeat Words" |
*
* @param {Style_Guide_Manager_Repeat_Words_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_repeat_words_label = /** @type {((inputs?: Style_Guide_Manager_Repeat_Words_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Repeat_Words_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_repeat_words_label(inputs)
	if (locale === "de") return de_style_guide_manager_repeat_words_label(inputs)
	if (locale === "it") return it_style_guide_manager_repeat_words_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_repeat_words_label(inputs)
	if (locale === "es") return es_style_guide_manager_repeat_words_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_repeat_words_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_repeat_words_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_repeat_words_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_repeat_words_label(inputs)
	return en_style_guide_manager_repeat_words_label(inputs)
});